module.exports = __webpack_public_path__ + "img/edg.b26efdb7.svg";